import React, { useState } from 'react';
import "../../iqac.css"
import TopNav from '../../../../../Components/TopNav';
import Navbar from '../../../../../Components/Navbar';
import DropdownNav from '../../../../../Components/DropdownNav';
import Footer from '../../../../../Components/Footer';
import Example from '../../../../../Components/Example';
import ScrollToTop from 'react-scroll-to-top';
const Distinctiveness = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [framework, setFramework] = useState(false)
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className='navbar-area'>
        <div className='distin-image'>
          <div className='image-cover'>

          </div>
        </div>

      </div>

      {/* This iqac details part */}

      <div className='iqac-details'>
        <div className='iqac-header'>
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className='iqac-obj-tit'>Distinctiveness</h1>
        </div>
      </div>

      {/* This is the body part of the iqac Objectives */}

      <div className='iqac-obj-det'>
        <button onClick={() => setIsOpen(e => !e)}           style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}>Distinctiveness</button>
        {
          isOpen && (
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/iqac/pdf/Distiv_2018-2019.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2018-2019</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/iqac/pdf/Distiv_2019-2020.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2019-2020</h3>
                  </a>
                </div>
              </div>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/iqac/pdf/Distiv_2020-21.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>2020-2021</h3>
                  </a>
                </div>
              </div>


            </div>
          )

        }


        <button onClick={() => setFramework(e => !e)}           style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}>Institutional Distinctiveness
        </button>
        {
          framework && (
            <div className='ssr-items'>
              {/* This is the starting node of AQARREPORTS */}
              <div>
                <div className='aqar-items'>
                  <a href='https://thenewcollege.edu.in/pdf/7.3.1-institutional_distinctiveness.pdf' target='new'>
                    <img src='https://sedge.in/New%20College/assest/logo.png' className='ssr-image' />
                    <h3>Institutional Distinctiveness</h3>
                  </a>
                </div>
              </div>
            </div>
          )
        }

      </div>

      <Footer />
    </div>
  );
}

export default Distinctiveness;
